enum ListingSource {
    TEVO = "TEVO",
    CUSTOM = "CUSTOM"
}

export default ListingSource;